import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

export const SEARCH_TYPES = {
  EVERYWHERE: 'everywhere',
};

export const NEARBY_AIRPORTS_PLACE = {
  origin: 'origin',
  destination: 'destination',
} as const;

export type NearbyAirportsPlaceType = Values<typeof NEARBY_AIRPORTS_PLACE>;
